import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'next-i18next';
import styles from '@/layout/centerLayout/CenterLayout.module.scss';
import ServicePlatformChoice from '@/components/common/ServicePlatformChoice/ServicePlatformChoice';
import { useRouter } from 'next/router';
import { useStore } from '@/utils/store';
import BreadCrumbs from '@/components/pages/center/breadCrumbs';
import SideBar from '@/components/pages/center/sideBar';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function CenterLayout({
  children,
  detail = '',
  showBreadcrumbs = true,
  nativeApp = false,
}) {
  const router = useRouter();
  const { user } = useStore().auth;
  const pathNameArr = router.pathname.split('/').filter((x) => x !== '');
  const keyPrefix = pathNameArr[0]?.replace('App', '') || '';
  const { t } = useTranslation('pages');

  const getPlatform = () => {
    if (user === false || user === undefined) {
      return <ServicePlatformChoice className={styles.newBg} />;
    }
    return '';
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      getPlatform();
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [user]);

  return (
    <main className={styles.page}>
      <div className={classnames(styles.bg, { [styles.nativeApp]: nativeApp })} />

      <div className={classnames(styles.page, { [styles.nativeApp]: nativeApp })}>
        <div className={styles.banner}>{t('header', { keyPrefix })}</div>

        <div className={styles.content}>
          <SideBar />

          <div className={styles.contentBody}>
            {showBreadcrumbs ? <BreadCrumbs detail={detail} /> : ''}
            {children}
          </div>

          {/* <div className={styles.module}>
            {getPlatform()}
          </div> */}
        </div>
      </div>

      <div className={styles.space}>&nbsp;</div>
    </main>
  );
}

CenterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  detail: PropTypes.instanceOf(Object),
  showBreadcrumbs: PropTypes.bool,
  nativeApp: PropTypes.bool,
};

CenterLayout.defaultProps = {
  detail: {},
  showBreadcrumbs: true,
  nativeApp: false,
};

export default observer(CenterLayout);
